import { getLocalizedOrDefault } from "../../../helpers/Functions";
import { getImageUrl } from "../../../helpers/PB";

const PromoConfig = {
  collection: "promos",
  fields: [
    "id",
    "name",
    "status",
    "locale.language",
    "locale.languages_code.code",
    "locale.image",
    "locale.link_type",
    "locale.link_url",
    "locale.link_text",
    "locale.pdf",
    "locale.comparison_page",
    "locale.heading",
    "locale.heading_disclaimer",
    "locale.body",
    "locale.body_disclaimer"
  ],

  filter: "filter[status][_eq]=active",

  adapter: class Promo {
    constructor(promo) {
      this.id = promo.id;
      this.name = promo.name;
      this.status = promo.status;

      let locale = promo.locale?.[0];
      this.locale = promo.locale;

      this.heading = locale?.heading;
      this.heading_disclaimer = locale?.heading_disclaimer?.id;
      this.body = locale?.body;
      this.body_disclaimer = locale?.body_disclaimer?.id;
      this.image_url = getImageUrl(locale?.image);
      this.link_type = locale?.link_type;
      this.link_text = locale?.link_text;
      this.link_url = locale?.link_url;
      this.pdf_url = getImageUrl(locale?.pdf);
      this.comparison_page = locale?.comparison_page?.id;

      this.hide_on_spe = this.link_type === "comparison";
      const spe_class = this.hide_on_spe ? "removeHrefForSPE" : "";
      this.link_class = this.link_type
        ? `link ${this.link_type} ${spe_class}`
        : "";
    }

    map(collections, maps) {
      this.comparison_page = maps.comparison_pages[this.comparison_page];
      this.heading_disclaimer = maps.disclaimers[this.heading_disclaimer];
      this.body_disclaimer = maps.disclaimers[this.body_disclaimer];

      const getLocalizedHref = (selected_locale) => {
        switch (this.getLocalized("link_type", selected_locale)) {
          case "web":
            return this.getLocalized("link_url", selected_locale);

          case "pdf":
            return this.getLocalized("pdf_url", selected_locale);

          case "comparison":
            const target_page = this.getLocalized(
              "comparison_page",
              selected_locale
            );
            const target_page_id = target_page?.id || target_page;
            const target_page_element = maps.comparison_pages[target_page_id];
            const target_page_html_id = target_page_element?.html_id;
            if (target_page_html_id) return `#${target_page_html_id}`;
            return "";

          default:
            return "";
        }
      };

      this.locale = this.locale.map(
        ({ languages_code, language, pdf, image, ...other_props }) => ({
          ...other_props,
          language:
            maps.languages?.[languages_code.code] || maps.locales?.[language],
          image: getImageUrl(image),
          pdf: getImageUrl(pdf)
        })
      );

      const { global_settings } = collections;
      const { default_locale } = global_settings;

      // e.g. field_name: header
      //      selected_locale: 'es-CL'
      this.getLocalized = (field_name, selected_locale) => {
        return getLocalizedOrDefault(
          this,
          field_name,
          { locale: selected_locale },
          { locale: default_locale?.language || default_locale }
        );
      };

      this.href = getLocalizedHref("en-US");
      this.getLocalizedHref = getLocalizedHref;
    }
  }
};

export default PromoConfig;
